// Tarjeta "Datos judiciales" — pestaña Resumen de la ficha de activo.
// Agrupa Juzgado, Fase judicial, Procedimiento y Notas de subasta. Sólo se
// muestra si al menos uno de los 4 campos tiene datos; dentro, los campos
// vacíos se ocultan tras un "+ Añadir" (editable sólo con permiso de
// edición general del activo — no requiere Admin/Superadmin).
import React from 'react';
import { InlineTextField, InlineSelectField } from './InlineTextField';
import { FASE_JUDICIAL_LIST } from '../constants/faseJudicial';

export const JudicialDataCard = ({ asset, canEdit, onSaved }) => {
  const tipoOperativo = (asset.tipo_activo_operativo || '').toUpperCase();
  const faseJudicialEditable = canEdit && (!tipoOperativo || tipoOperativo === 'CREDITO');
  const faseJudicialDisabledTitle = tipoOperativo && tipoOperativo !== 'CREDITO'
    ? 'Fase judicial solo aplica a activos de tipo Crédito' : undefined;

  const hasData = !!(asset.juzgado || asset.fase_judicial || asset.numero_procedimiento || asset.notas_subasta);
  if (!hasData) return null;

  return (
    <div className="card-base p-6" data-testid="judicial-data-card">
      <h3 className="heading-3 mb-4">Datos judiciales</h3>
      <div className="space-y-1" data-testid="judicial-data-fields">
        <InlineTextField assetId={asset.id} field="juzgado" value={asset.juzgado} label="Juzgado"
          editable={canEdit} onSaved={onSaved} testid="judicial-juzgado" hideWhenEmpty />
        <InlineSelectField assetId={asset.id} field="fase_judicial" value={asset.fase_judicial} label="Fase judicial"
          options={FASE_JUDICIAL_LIST} editable={faseJudicialEditable} disabledTitle={faseJudicialDisabledTitle}
          onSaved={onSaved} testid="judicial-fase-judicial" hideWhenEmpty />
        <InlineTextField assetId={asset.id} field="numero_procedimiento" value={asset.numero_procedimiento} label="Procedimiento"
          editable={canEdit} onSaved={onSaved} testid="judicial-procedimiento" hideWhenEmpty />
        <InlineTextField assetId={asset.id} field="notas_subasta" value={asset.notas_subasta} label="Notas de subasta"
          editable={canEdit} onSaved={onSaved} testid="judicial-notas-subasta" multiline hideWhenEmpty />
      </div>
    </div>
  );
};

export default JudicialDataCard;
